import cn from 'classnames';
import { assertDateString, DateString } from 'common/UrlDate';
import { ExploreShefCardLocation } from 'src/pages/consumer/dish-first/explore/components/Segments/ExploreShefCard';
import { ShefDefaultAvatar } from 'src/shared/design-system/Icon/ShefDefaultAvatar';
import { SHEF_IMAGE_DIMENSIONS, ShefImage } from './styles';

export type ShefAvailabilityDateString = DateString | 'no_availability';
export const NO_AVAILABILITY_DATE_STRING = 'no_availability';

interface ShefCardAvatarProps {
  shef: {
    imageUrl?: string | null | undefined;
    publicName: string;
  };
  width?: number;
  height?: number;
  className?: string;
}

export const ShefCardAvatar: React.FC<ShefCardAvatarProps> = ({
  shef,
  width = SHEF_IMAGE_DIMENSIONS,
  height = SHEF_IMAGE_DIMENSIONS,
  className,
}): JSX.Element => {
  const imageComponent = shef.imageUrl ? (
    <ShefImage
      src={shef.imageUrl}
      alt={shef.publicName}
      sourceWidth={width}
      sourceHeight={height}
      className={'relative'}
    />
  ) : (
    <ShefDefaultAvatar width={`${width}px`} height={`${height}px`} className={'relative'} />
  );

  return (
    <div className={cn(className, 'relative')}>
      <div
        className='absolute left-0 top-0 -ml-1 -mt-1 rounded-full bg-white'
        style={{ width: width + 8, height: height + 8 }}
      />
      {imageComponent}
    </div>
  );
};

export const getShefAvailabilityDateString = (
  availability: {
    __typename?: 'ShefAvailability' | undefined;
    availabilityDate: string;
  }[],
  location: ExploreShefCardLocation,
  deliveryDate?: DateString
): ShefAvailabilityDateString | null => {
  const currentDeliveryDate = availability
    ? availability.find((shefAvailability) => shefAvailability.availabilityDate === deliveryDate)
    : undefined;
  if (currentDeliveryDate) {
    return location === 'search-page' ? assertDateString(currentDeliveryDate.availabilityDate) : null;
  }
  const nextAvailability = availability
    ? availability.find((shefAvailability) => shefAvailability.availabilityDate !== deliveryDate)
    : undefined;
  return nextAvailability ? assertDateString(nextAvailability.availabilityDate) : 'no_availability';
};
